export default __webpack_public_path__ + "static/media/26.b8c66de2.jpg";